import React from 'react'
import EffConfigCard, { FieldRow, BoolBadge, NumericValue } from './EffConfigCard'
import { LuminaireEffectiveRelay, LuminaireEffectiveSensors } from '../../types/luminaire.types'

// Relais / E·S: internal relay + open-drain output, plus the folded-in sensor
// readings (light sensor, digital input).
export default function RelaisCard({
  relay,
  sensors,
  tooltip,
}: {
  relay: LuminaireEffectiveRelay | null
  sensors: LuminaireEffectiveSensors | null
  tooltip?: string
}) {
  return (
    <EffConfigCard title="Relais / E·S" tooltip={tooltip}>
      <FieldRow label="Relais interne">
        <BoolBadge value={relay?.internal_relay_closed ?? null} trueLabel="Fermé" falseLabel="Ouvert" />
      </FieldRow>
      <FieldRow label="Sortie open-drain">
        <BoolBadge value={relay?.open_drain_output_on ?? null} trueLabel="On" falseLabel="Off" />
      </FieldRow>
      <FieldRow label="Luminosité">
        <NumericValue value={sensors?.light_sensor_lux ?? null} unit="lux" />
      </FieldRow>
      <FieldRow label="Entrée dig. 1">
        <BoolBadge value={sensors?.dig_input_1_on ?? null} trueLabel="On" falseLabel="Off" />
      </FieldRow>
    </EffConfigCard>
  )
}
